import { useQuery } from '@apollo/client'
import { getVideoLeadThumbnail } from '../../api'
import { getLiveImageSizes } from '../../config'

/**
 * Fetches a video's poster at hero/lead scale by ID, for components that render a video's
 * thumbnail at full-width or half-viewport scale (e.g. MediaPromo) rather than card scale.
 * Returns undefined while loading or if unavailable, so callers should fall back to their
 * existing (card-sized) thumbnail source until this resolves.
 */
export default function useLeadVideoThumbnail(videoId?: string): string | undefined {
  const { leadThumbnailImage } = getLiveImageSizes()
  const { data } = useQuery(getVideoLeadThumbnail(), {
    variables: { id: videoId, ...leadThumbnailImage },
    skip: !videoId,
  })

  return data?.VideoDetail?.thumbnail?.custom?.image?.src
}
